import { Portal as ChakraPortal, type PortalProps as ChakraPortalProps } from '@chakra-ui/react'

import React, { PropsWithChildren, ReactNode, createContext, useContext, useRef } from 'react'
import { cssVariables } from 'utils'
import Flex from '../Flex'

export type PortalProps = PropsWithChildren<ChakraPortalProps>

export function Portal(props: PortalProps) {
  const { containerRef } = useContext(PortalContext)
  return <ChakraPortal container={containerRef} {...props} />
}

interface PortalContextValue {
  containerRef: React.RefObject<HTMLDivElement | null>
}

const PortalContext = createContext<PortalContextValue>({} as any)

interface Props {
  children: ReactNode
}

/** Wrap app in provider to mount portals below changes made to css variables TODO: try to remove this by preventing to handle css variables manually */
export const PortalProvider = ({ children }: Props) => {
  const containerRef = useRef<HTMLDivElement>(null)

  return (
    <PortalContext.Provider value={{ containerRef }}>
      <Flex
        ref={containerRef}
        css={{ base: cssVariables.light, _dark: cssVariables.dark }}
        overflow="hidden"
        height="100%"
        width="100%"
      >
        {children}
      </Flex>
    </PortalContext.Provider>
  )
}
